import { Component } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import * as moment from 'moment-timezone';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { NavigationEnd, Router } from '@angular/router';
import { gsap, Expo, Quad } from 'gsap';
import { PageDataService } from 'src/app/services/page-data.service';

@Component({
  selector: 'app-show-list-page',
  templateUrl: './show-list-page.component.html',
  styleUrls: ['./show-list-page.component.scss']
})
export class ShowListPageComponent {
    public today : Date
    public data: any
    public isWhereToWatchOpen: boolean = false
    public jsonData: any
    isMobile: boolean = false;

    constructor(
        public apiService: ApiService ,
        private router: Router,
        private breakpointObserver: BreakpointObserver,
        public pageData: PageDataService
    ) {
        breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            if (result.matches) {
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
        });

        this.today = new Date() 

        this.jsonData = [
            {
                id: 'movie-sphere',
                db: 'moviesphere-posters',
                title: 'MovieSphere',
                path: '/movie-sphere',
                apiType: 'xml',
                apiUrl: 'assets/json/MOVSP.xml',
                bg: 'assets/img/moviesphere/moviesphere-top-image-desktop.jpg',
                bgMobile: 'assets/img/mobile/moviesphere-mobile-header.jpg',
                logo: 'assets/img/moviesphere/movie-sphere-large-logo.png',
                quote: 'MovieSphere is the place to find blockbuster hits to indie favorites and everything in between.',
                descriptionColor: '#fff',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
                calendarColor1: '#460cb9',
                calendarColor2: '#9d1b90',
                calendarColor3: '#f3e3f2',
                calendarColor4: '#fff',
                defaultThumb: 'assets/img/MovieSphere_EPGChannelImage_1920x1080.jpg',
                youtube: 'https://www.youtube.com/@MovieSphereClips',
                instagram: 'https://www.instagram.com/moviesphere',
                facebook: 'https://www.facebook.com/MovieSphereOfficial',
                isChannelPreviewOn: true,
                whereToWatch : [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: 'https://www.amazon.com/gp/video/splash/freevee_findus',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://www.roku.com/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: 'https://www.lg.com/levant_en/tvs/2022/ott',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: 'https://www.xumo.com/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https:/plex.tv/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: 'https://tubi.tv/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/samsungtvplus.png',
                        link: 'https://www.samsung.com/us/televisions-home-theater/tvs/tvplus/',
                    },

                ]
            },
            {
                id: 'outer-sphere',
                db: 'outersphere-posters',
                path: '/outer-sphere',
                title: 'OuterSphere',
                // apiType: 'json',
                apiType: 'xml',
                apiUrl: 'assets/json/OTSPR.xml',
                bg: 'assets/img/outersphere/outersphere-top-image-desktop.jpg',
                bgMobile: 'assets/img/mobile/outersphere-mobile-header.jpg',
                logo: 'assets/img/outersphere/outer-sphere-large-logo.png',
                quote: 'From superheroes to the supernatural, monsters to magicians, blockbusters to cult classics, OuterSphere has your sci-fi favorites.',
                descriptionColor: '#fff',
                color1: '#4c7702',
                color2: '#92e600',
                color3: '#f2fce0',
                color4: '#000',
                calendarColor1: '#4c7702',
                calendarColor2: '#92e600',
                calendarColor3: '#000',
                calendarColor4: '#fff',
                defaultThumb: 'assets/img/OuterSphere_EPGChannelImage_1920x1080.jpg',
                youtube: 'https://www.youtube.com/@OuterSphereClips',
                isChannelPreviewOn: true,
                whereToWatch : [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: 'https://www.amazon.com/gp/video/splash/freevee_findus',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/roku.png',
                    //     link: 'https://www.roku.com/',
                    // },
                    // {
                    //     logo: 'assets/img/streaming-logos/lg-channels.png',
                    //     link: 'https://www.lg.com/levant_en/tvs/2022/ott',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: 'https://www.xumo.com/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: 'https://tubi.tv/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/samsungtvplus.png',
                        link: 'https://www.samsung.com/us/televisions-home-theater/tvs/tvplus/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https:/plex.tv/',
                    },
                   
                    

                ]
            },
            {
                id: 'her-sphere',
                db: 'hersphere-posters',
                path: '/her-sphere',
                title: 'HerSphere',
                apiType: 'xml',
                apiUrl: 'assets/json/HERSPH.xml',
                bg: 'assets/img/hersphere/hersphere-top-image-desktop.jpg',
                bgMobile: 'assets/img/mobile/hersphere-mobile-header.jpg',
                logo: 'assets/img/hersphere/hersphere-large-logo.png',
                quote: 'HerSphere brings together the female-driven stories you love from Lionsgate’s premium library and beyond.',
                descriptionColor: '#fff',
                color1: '#460cb9',
                color2: '#0bfda8',
                color3: '#e6e1ec',
                color4: '#300561',
                calendarColor1: '#460cb9',
                calendarColor2: '#0bfda8',
                calendarColor3: '#460cb9',
                calendarColor4: '#fff',
                defaultThumb: 'assets/img/HerSphere_EPGChannelImage_1920x1080.jpg',
                youtube: 'https://www.youtube.com/@HerSphereClips',
                isChannelPreviewOn: true,
                whereToWatch : [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: 'https://www.amazon.com/gp/video/splash/freevee_findus',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://www.roku.com/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: 'https://www.lg.com/levant_en/tvs/2022/ott',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                    //     link: 'https://www.xumo.com/',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https:/plex.tv/',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/tubi.png',
                    //     link: 'https://tubi.tv/',
                    // },
                    // {
                    //     logo: 'assets/img/streaming-logos/samsungtvplus.png',
                    //     link: 'https://www.samsung.com/us/televisions-home-theater/tvs/tvplus/',
                    // },

                ]
            },
            {
                id: 'ebonytv',
                db: 'ebonytv-posters',
                path: '/ebonytv',
                apiType: 'xml',
                title: 'Ebony TV',
                apiUrl: 'assets/json/MVSBK.xml',
                bg: 'assets/img/ebonytv/ebonytv-top-image-desktop-v2.jpg',
                bgMobile: 'assets/img/mobile/ebonytv-mobile-header-v2.jpg',
                logo: 'assets/img/ebonytv/ebonytv-large-logo-v2.png',
                quote: 'EBONY TV features award-winning films, engaging comedies, and groundbreaking series that celebrate the global richness of Black culture.',
                descriptionColor: '#fff',
                color1: '#7e0000',
                color2: '#ff0000',
                color3: '#fdc3c3',
                color4: '#fff',
                calendarColor1: '#7e0000',
                calendarColor2: '#ff0000',
                calendarColor3: '#fdc3c3',
                calendarColor4: '#fff',
                defaultThumb: 'assets/img/EbonyTV_EPGChannelImage_1920x1080.jpg',
                isChannelPreviewOn: true,
                whereToWatch : [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: 'https://www.amazon.com/gp/video/splash/freevee_findus',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://www.roku.com/',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/lg-channels.png',
                    //     link: 'https://www.lg.com/levant_en/tvs/2022/ott',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: 'https://tubi.tv/',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                    //     link: 'https://www.xumo.com/',
                    // },
                    
                    
                    {
                        logo: 'assets/img/streaming-logos/samsungtvplus.png',
                        link: 'https://www.samsung.com/us/televisions-home-theater/tvs/tvplus/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https:/plex.tv/',
                    },

                ]
            },
            {
                id: '50centaction',
                db: '50centaction-posters',
                path: '/50centaction',
                apiType: 'xml',
                title: '50 CENT ACTION Channel',
                apiUrl: 'assets/json/ACTION.xml',
                bg: 'assets/img/50centaction/50centaction-desktop-header.jpg',
                bgMobile: 'assets/img/50centaction/50centaction-mobile-header.jpg',
                logo: 'assets/img/50centaction/50centaction-logo.png',
                quote: '50 Cent Action brings you high-octane movies and series, curated by 50 Cent himself, for the ultimate thrill ride.',
                descriptionColor: '#fff',
                color1: '#333333',
                color2: '#cd192c',
                color3: '#808080',
                color4: '#fff',
                calendarColor1: '#333333',
                calendarColor2: '#000',
                calendarColor3: '#cd192c',
                calendarColor4: '#fff',
                defaultThumb: 'assets/img/50centaction_epgchannelimage.jpg',
                tiktok: 'https://www.tiktok.com/@50centactiontv',
                instagram: 'https://www.instagram.com/50centaction/',
                isChannelPreviewOn: true,
                whereToWatch : [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: 'https://www.amazon.com/gp/video/splash/freevee_findus',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://www.roku.com/',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/lg-channels.png',
                    //     link: 'https://www.lg.com/levant_en/tvs/2022/ott',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: 'https://tubi.tv/',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                    //     link: 'https://www.xumo.com/',
                    // },
                    
                    
                    {
                        logo: 'assets/img/streaming-logos/samsungtvplus.png',
                        link: 'https://www.samsung.com/us/televisions-home-theater/tvs/tvplus/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https:/plex.tv/',
                    },

                ]
            },
            {
                id: 'lawless',
                db: 'lawless-posters',
                path: '/lawless',
                apiType: 'xml',
                title: 'Lawless Channel',
                apiUrl: 'assets/json/LAWLESS.xml',
                bg: 'assets/img/lawless/lawless-page-top-background-desktop-v2.jpg',
                // bgMobile: 'assets/img/lawless/lawless-homepage-promo-background-mobile.jpg',
                // bgMobile: 'assets/img/lawless/lawless-page-top-background-mobile.jpg',
                bgMobile: 'assets/img/lawless/Lawless-page-background-top-mobile.jpg',
                logo: 'assets/img/lawless/lawless-logo-desktop-v2.png',
                quote: 'Dive into the criminal underworld where justice is a game, <br>and the stakes are high.',
                quoteMobile: 'Dive into the criminal underworld where justice is a game, and the stakes are high.<br><br>',
                descriptionColor: '#c7b092',
                color1: '#5B3206',
                color2: '#000',
                color3: '#D5B58F',
                color4: '#fff',
                calendarColor1: '#895614',
                calendarColor2: '#000',
                calendarColor3: '#D5B58F',
                calendarColor4: '#fff',
                defaultThumb: 'assets/img/Lawless_epgchannelimage.jpg',
                isChannelPreviewOn: false,
                whereToWatch : [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: 'https://www.amazon.com/gp/video/splash/freevee_findus',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://www.roku.com/',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/lg-channels.png',
                    //     link: 'https://www.lg.com/levant_en/tvs/2022/ott',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: 'https://tubi.tv/',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                    //     link: 'https://www.xumo.com/',
                    // },
                    
                    
                    {
                        logo: 'assets/img/streaming-logos/samsungtvplus.png',
                        link: 'https://www.samsung.com/us/televisions-home-theater/tvs/tvplus/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https:/plex.tv/',
                    },

                ]
            },
            {
                id: 'extreme-jobs',
                db: 'extreme-jobs-posters',
                path: '/extreme-jobs',
                apiType: 'xml',
                title: 'Extreme Jobs Channel',
                apiUrl: 'assets/json/ExtremeJobs.xml',
                bg: 'assets/img/extreme-jobs/Extreme-Jobs-page-top-background-desktop-v2.jpg',
                bgMobile: 'assets/img/extreme-jobs/Extreme-Jobs-page-background-top-mobile.jpg',
                // logo: 'assets/img/extreme-jobs/Extreme-Jobs-title.png',
                logo: 'assets/img/extreme-jobs/Extreme-Jobs-large-logo.png',
                quote: 'Experience thrilling gold rushes, high seas drama, masterful log home builds, dedicated animal care in the Scottish Highlands, and adrenaline-pumping storm chases. Every show is an adventure.',
                quoteMobile: 'Experience thrilling gold rushes, high seas drama, masterful log home builds, dedicated animal care in the Scottish Highlands, and adrenaline-pumping storm chases. Every show is an adventure.',
                descriptionColor: '#fff',
                color1: '#0D2320',
                color2: '#112524',
                color3: '#678e8e',
                color4: '#fff',
                calendarColor1: '#183835',
                calendarColor2: '#112524',
                calendarColor3: '#678e8e',
                calendarColor4: '#fff',
                defaultThumb: 'assets/img/extreme-jobs_epgchannelimage.jpg',
                isChannelPreviewOn: false,
                whereToWatch : [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: 'https://www.amazon.com/gp/video/splash/freevee_findus',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://www.roku.com/',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/lg-channels.png',
                    //     link: 'https://www.lg.com/levant_en/tvs/2022/ott',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: 'https://tubi.tv/',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                    //     link: 'https://www.xumo.com/',
                    // },
                    
                    
                    {
                        logo: 'assets/img/streaming-logos/samsungtvplus.png',
                        link: 'https://www.samsung.com/us/televisions-home-theater/tvs/tvplus/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https:/plex.tv/',
                    },

                ]
            },

        ]

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                let url = event.urlAfterRedirects
                url = url.split('?')[0]

                this.data = this.jsonData.find((item) => {
                    return item.path == url
                });
                if( this.data && !this.data.quoteMobile) {
                    this.data.quoteMobile = this.data.quote
                }

                var startDate = moment().format('YYYY-MM-DD')
                if(url == '/50centaction') {
                    startDate = '2024-12-10'
                }

                if(this.data) {
                    if(this.data.apiType == 'json') {
                        this.apiService.getApiData1(this.data.defaultThumb)
                    }
                    else {
                        this.apiService.loadXML(this.data.apiUrl, this.data.defaultThumb, startDate)
                    }
                }

                if(this.data == undefined) {
                    // TODO: redirect to 404
                }
                else {
                    if(window.location.href.indexOf("hybridstudio") != -1 || window.location.href.indexOf("localhost:") != -1 ) {
                        this.apiService.getPosterList(this.data.db + '-test')    
                    }
                    else {
                        this.apiService.getPosterList(this.data.db)
                    }
                }

                this.animateIn();
            }
        })
        
    }

    animateIn() {

    }

    onWhereToWatch() {
        if(this.isWhereToWatchOpen) {
            // close
            gsap.to('.whereToWatchList', 0.5, {height: '0vw' });
        }
        else {
            // open
            // gsap.to('.whereToWatchList', 0.5, {height: '44vw' });
            if(!this.isMobile) {
                // let height = document.getElementsByClassName('whereToWatchList')[0].getClientRects()[0].height
                let size = 20;
                
                let rowCount = Math.ceil( this.pageData.get(this.data.path)?.whereToWatch.length / 4 ) 
                size += rowCount * 14;

                gsap.to('.whereToWatchList', 0.5, {height: size + 'vw' });
                // gsap.to('.whereToWatchList', 0.5, {height: height + 'px' });
            }
            else {
                let rowCount = Math.ceil( this.pageData.get(this.data.path)?.whereToWatch.length / 3 ) 
                let size = 45;
                size += rowCount * 25;
                gsap.to('.whereToWatchList', 0.5, {height: size + 'vw' });
                // gsap.to('.whereToWatchList', 0.5, {height: height + 'px' });
            }
        }
        this.isWhereToWatchOpen = !this.isWhereToWatchOpen;
    }

    onWhereToWatchClose() {
        gsap.to('.whereToWatchList', 0.5, {height: '0vw' });
        this.isWhereToWatchOpen = false
    }

    dropdownButtonOver(event) {
        gsap.to(event.target, 0.3, {backgroundColor: this.data.color1, borderColor: this.data.color1, color: this.data.color4, ease: Quad.easeOut});

        gsap.to(event.target.getElementsByTagName('path'), 0.3, {fill: this.data.color4, ease: Quad.easeOut});
    }

    dropdownButtonOut(event) {
        gsap.to(event.target, 0.3, {backgroundColor: 'rgba(255,255,255, 0)', borderColor: 'rgba(255,255,255, 0.5)', color: '#fff', ease: Quad.easeOut});

        gsap.to(event.target.getElementsByTagName('path'), 0.3, {fill: '#fff', ease: Quad.easeOut});
    }

    onOpenSizzleOverlay(path: string) {
        this.pageData.openOverlay(this.data.path)
    }
}
